import type { ReactNode } from 'react';

export const symbol_align_space_even: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-290q-12.75 0-21.37-8.63Q290-307.25 290-320v-40q0-12.75 8.63-21.38Q307.25-390 320-390h320q12.75 0 21.38 8.62Q670-372.75 670-360v40q0 12.75-8.62 21.37Q652.75-290 640-290H320Zm0-280q-12.75 0-21.37-8.63Q290-587.25 290-600v-40q0-12.75 8.63-21.38Q307.25-670 320-670h320q12.75 0 21.38 8.62Q670-652.75 670-640v40q0 12.75-8.62 21.37Q652.75-570 640-570H320ZM110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80H110Zm0-740q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-880 110-880h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Z"
		/>
	</svg>
);
